import * as v from "valibot";

import { rpcContract } from "../rpc";

export const createPostRpcContract = rpcContract({
  name: "createPost",
  paramsSchema: v.object({
    description: v.pipe(v.string(), v.maxLength(750)),
    worldIds: v.array(v.string()),
    newWorldNames: v.array(v.string()),
    brandIds: v.array(v.string()),
    ctaData: v.optional(
      v.object({
        callToAction: v.pipe(v.string(), v.minLength(1), v.maxLength(64)),
        url: v.pipe(v.string(), v.url()),
      }),
    ),
    discountData: v.optional(
      v.object({
        code: v.pipe(v.string(), v.minLength(1), v.maxLength(64)),
      }),
    ),
    faqBlocks: v.array(
      v.object({
        question: v.pipe(v.string(), v.minLength(1), v.maxLength(150)),
        answer: v.pipe(v.string(), v.minLength(1), v.maxLength(250)),
      }),
    ),
    fileId: v.string(),
    startDate: v.optional(v.pipe(v.string(), v.isoDateTime())),
    cover: v.boolean(),
    contentTier: v.optional(v.picklist(["free", "premium"])),
    oneTimePriceCents: v.optional(v.pipe(v.number(), v.minValue(100), v.maxValue(99999))),
  }),
  resultSchema: v.object({
    postId: v.string(),
  }),
});

export type CreatePostParams = v.InferOutput<(typeof createPostRpcContract)["paramsSchema"]>;

export type CreatePostResult = v.InferOutput<(typeof createPostRpcContract)["resultSchema"]>;
